import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetServiceContactDelegationList } from "DelegationService/DelegationService/Domain/Responses/ServiceContactDelegation/GetServiceContactDelegationList";

export async function getServiceContactDelegationList(data) {
    let response = await getAPIResponse("/v1/service-contact-delegation-list", data);
    if (response === null) {
        return null;
    }
    let getServiceContactDelegationList = GetServiceContactDelegationList.createFromResponseData(response);
    return getServiceContactDelegationList;
}